import api, { apiErrorHandler } from "api";
import { FalconConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";
import { FalconCommentData, FalconCommentDataContent, FalconPlanData } from "types/Falcon";

export const getFalconData =
  (params: { station?: string; year?: number; month?: number; week?: number }) =>
  (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_ERROR });
    dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_LOADING });
    api
      .getFalconData(params)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: FalconConstants.FALCON_TABLE_GET_DATA_SUCCESS,
            payload: {
              dateList: res?.data.date_list,
              standardList: res?.data.standard_list,
              planList: res?.data.plan_list,
              commentList: res?.data.comment_list,
            },
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const falconEditPlan = (type: string, planList: FalconPlanData[]) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { falconFilters } = getStore()?.falconTable;
    const onError = () => dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_ERROR });
    dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_LOADING });

    api
      .createOrUpdateReportPlan({
        week: Number(falconFilters.date.week.split("-W")[1]) - 1,
        year: Number(falconFilters.date.week.split("-W")[0]),
        type: type,
        plan_list: planList,
        station: falconFilters?.station,
      })
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: FalconConstants.FALCON_TABLE_UPDATE_PLANS,
            payload: res?.data
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const falconEditComment =
  (
    date: string | number | undefined,
    comment: string,
    commentContentList: FalconCommentDataContent[],
    matchStatus: number | undefined,
  ) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { falconData, falconFilters } = getStore()?.falconTable;
    const onError = () => dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_ERROR });
    dispatch({ type: FalconConstants.FALCON_TABLE_GET_DATA_LOADING });
    api
      .createOrUpdateReportComment({
        date,
        comment,
        commentList: JSON.stringify(commentContentList),
        matchStatus: matchStatus,
        station: falconFilters?.station,
      })
      .then((res) => {
        if (res?.data?.data) {
          const res_is_created = res?.data?.created;
          const res_editor_first_name = res?.data?.data?.editor__first_name;
          const res_editor_last_name = res?.data?.data?.editor__last_name;
          
          const res_edited = res?.data?.data?.edited;
          const newItem = {
            report_date: date,
            report_comment: comment,
            is_match: matchStatus,
            content: commentContentList,
            editor__first_name: res_editor_first_name,
            editor__last_name: res_editor_last_name,
            edited: res_edited,
          };

          const updatedCommentList = falconData.commentList.map((item: FalconCommentData) =>
            item?.report_date === date ? newItem : item,
          );

          dispatch({
            type: FalconConstants.FALCON_TABLE_UPDATE_COMMENTS,
            payload: res_is_created ? [newItem, ...falconData.commentList] : updatedCommentList,
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const falconSetStation =
  (station?: string) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { falconFilters } = getStore()?.falconTable;
    dispatch({
      type: FalconConstants.FALCON_PAGE_CHANGE_FILTERS,
      payload: { ...falconFilters, station },
    });
  };

export const falconSetDate =
  (data: { week?: string; month?: string; year?: string }) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { falconFilters } = getStore()?.falconTable;
    dispatch({
      type: FalconConstants.FALCON_PAGE_CHANGE_DATE_FILTERS,
      payload: { ...falconFilters?.date, ...data },
    });
  };

export const falconSetType = (type: string) => (dispatch: Dispatch) => {
  dispatch({
    type: FalconConstants.FALCON_PAGE_CHANGE_TYPE,
    payload: type,
  });
};
